var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.allowEmbed())?_c('div',[_c('Checkout',{attrs:{"prop_id":_vm.id,"prop_url":_vm.url,"prop_domain":_vm.domain,"prop_settings":_vm.settings,"prop_form":_vm.form,"prop_belongs_to":_vm.belongs_to,"prop_checkout_id":_vm.checkout_id,"prop_embed":_vm.embed,"prop_ref":_vm.ref}})],1):_c('div',[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }